<meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
<meta http-equiv="Pragma" content="no-cache">
<meta http-equiv="Expires" content="0">

  <mat-card>
    <mat-card-header class="header-model">
      <div>
        <span>
          Change Password
        </span>
      </div>
    </mat-card-header>
    <br>
    <mat-card-content>
      <form [formGroup]="ChangePass" (ngSubmit)="onFormSubmit()">
        <div class="row">
          <label>User ID : </label>
          <div class="input-group">
            <span class="input-group-addon">
              <i class="icofont icofont-user"></i>
            </span>
            <input type="text" class="form-control" formControlName="userID" readonly>
          </div>
          <div *ngIf="userID?.invalid && userID?.touched">
            <span style="color:red;margin-top:3px">*</span>
          </div>
        </div>

        <br />

        <div class="row">
          <label>Password : </label>
          <div class="input-group">
            <input type="text" class="form-control" [type]="hide1 ? 'password' : 'text'" formControlName="userPassword" placement="top" maxlength="{{int_maxLen_password}}" (keyup)="passwordKey($event)" (keydown.space)="$event.preventDefault()" (keypress)="allowCharactersInInputFields($event)">
            <button mat-icon-button matSuffix type="button" (click)="hide1 = !hide1">
              <mat-icon>{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </div>


          <div *ngIf="!userPassword?.valid && userPassword?.touched" class="form__error" style="color:red;margin-top:3px;font-weight: bold;">
            {{userPassword?.errors?.['required']}}
          </div>
          <br>
          <div *ngIf="alertMessage && userPassword?.value" style="color:Red">
            <b> {{alertMessageText}} </b>
          </div>
        </div>
        <br/>
        <div class="row">
          <label> Confirm Password : </label>

           <div class="input-group">
            <input type="text" class="form-control" [type]="hide2 ? 'password' : 'text'" formControlName="userConfirmPassword" placement="top" maxlength="{{int_maxLen_password}}"  (keydown.space)="$event.preventDefault()" (keypress)="allowCharactersInInputFields($event)">
            <button mat-icon-button matSuffix type="button" (click)="hide2 = !hide2">
              <mat-icon>{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </div>
        
          <div *ngIf="!userConfirmPassword?.valid && userConfirmPassword?.touched" style="color:red;margin-top:3px;font-weight: bold;">
            {{userConfirmPassword?.errors?.['required']}}
          </div>
          <br>
          <div *ngIf="ChangePass.controls['userConfirmPassword'].dirty">
            <div *ngIf="ChangePass.controls['userConfirmPassword'].errors && ChangePass.controls['userConfirmPassword'].errors['matchOther']">
              <b style="color:red;">*Password Mismatched</b>
            </div>
          </div>
        </div>

        <br />
        <div style="text-align: center;">
          <button type="submit" [disabled]="!ChangePass.valid" [ngClass]="{disabledBtn:!ChangePass.valid}" class="btn btn-primary"><i class="fa fa-check-circle-o"></i> Save</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button class="btn  btn-secondary" style="width: 120px;" type="button" (click)="btnClose_onClick()"><i class="fa fa-times-circle-o"></i> Close</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
